import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M19.27 19.496H8.076C7.662 19.496 7.326 19.16 7.326 18.746C7.326 18.332 7.662 17.996 8.076 17.996H19.27C19.949 17.996 20.5 17.392 20.5 16.651V10.5H3.5V16.883C3.5 17.387 4.049 17.996 4.731 17.996H5.023C5.437 17.996 5.773 18.332 5.773 18.746C5.773 19.16 5.437 19.496 5.023 19.496H4.731C3.276 19.496 2 18.275 2 16.883V7.877C2 6.183 3.123 5 4.731 5H19.27C20.775 5 22 6.291 22 7.877V16.651C22 18.22 20.775 19.496 19.27 19.496ZM3.5 9H20.5V7.877C20.5 7.13 19.937 6.5 19.27 6.5H4.731C3.949 6.5 3.5 7.002 3.5 7.877V9V9Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'CreditCard');

export default Icon;
